import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

interface UsePageViewTrackingOptions {
  enabled?: boolean;
  /** Only track the landing page of the session, not in-app navigation. Defaults to true. */
  entryOnly?: boolean;
  /** Only track events where at least one utm_ parameter is present. Defaults to false. */
  requireUtm?: boolean;
  slug?: string;
  title?: string;
}

export function usePageViewTracking({
  enabled = true,
  entryOnly = true,
  requireUtm = false,
  slug,
  title,
}: UsePageViewTrackingOptions = {}): void {
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;

    void trackPageView(
      {
        path: `${location.pathname}${location.search}`,
        slug,
        title,
        referrer: typeof document === 'undefined' ? undefined : document.referrer || undefined,
        search: location.search,
      },
      { entryOnly, requireUtm },
    );
  }, [enabled, entryOnly, requireUtm, location.pathname, location.search, slug, title]);
}
